module.exports = __webpack_public_path__ + "static/Stasts-value-a83fcb0ed655b46bb52f611396e28148.svg";